import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { formateDate } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import * as clubAdmin from "../../../services/clubAdmin.service";

const ClubAdminView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Club"), url: "/admin/user-management/club-admins/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    clubAdmin
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const adminName = `${showdefault?.firstName || ""} ${showdefault?.lastName || ""}`.trim() || showdefault?.name || "N/A";
  const clubName = showdefault?.clubDetails?.name || showdefault?.clubName || "N/A";
  const adminEmail = showdefault?.email || "N/A";
  const clubEmail = showdefault?.clubDetails?.email || showdefault?.clubEmail || "N/A";

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    {/* Club Admin Details */}
                    <div>
                      <h6 className="main-content-label mb-3">Club Admin View</h6>
                    </div>
                    <table id="admin-table" className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Club Admin Name</th>
                          <td className="text-capitalize">{adminName}</td>
                        </tr>
                        <tr>
                          <th>Club Admin Email</th>
                          <td>{adminEmail}</td>
                        </tr>
                        <tr>
                          <th>Username</th>
                          <td>{showdefault?.username || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Verification Status</th>
                          <td className="text-capitalize">
                            {showdefault?.isBlocked ? (
                              <span className="badge badge-pill badge-danger-light fw-bold text-uppercase">Blocked</span>
                            ) : showdefault?.isProfileVerified === "verified" ? (
                              <span className="badge badge-pill badge-success-light fw-bold text-uppercase">Verified</span>
                            ) : showdefault?.isProfileVerified === "rejected" ? (
                              <span className="badge badge-pill badge-danger-light fw-bold text-uppercase">Rejected</span>
                            ) : (
                              <span className="badge badge-pill badge-warning-light fw-bold text-uppercase">Pending</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Club Details */}
                    <div>
                      <h6 className="main-content-label mb-3">Club View</h6>
                    </div>
                    <table id="club-table" className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Club Logo / Picture</th>
                          <td>
                            {((showdefault?.clubDetails?.image && showdefault.clubDetails.image !== "N/A") || (showdefault?.profile_image && showdefault.profile_image !== "N/A")) ? (
                              <img 
                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }}
                                src={showdefault?.clubDetails?.image && showdefault.clubDetails.image !== "N/A" ? showdefault.clubDetails.image : showdefault.profile_image} 
                                alt="Profile" 
                              />
                            ) : (
                              <div style={{ width: '50px', height: '50px', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', fontSize: '10px', color: '#9ca3af' }}>
                                No Image
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>Club Name</th>
                          <td className="text-capitalize">{clubName}</td>
                        </tr>
                        <tr>
                          <th>Club Email</th>
                          <td>{clubEmail}</td>
                        </tr>
                        <tr>
                          <th>{t("label_address")}</th>
                          <td>
                            {showdefault?.clubDetails?.address || showdefault?.address || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_city")}</th>
                          <td>
                            {showdefault?.clubDetails?.city || showdefault?.city || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_county")}</th>
                          <td>
                            {showdefault?.clubDetails?.state || showdefault?.state || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_country")}</th>
                          <td>
                            {showdefault?.clubDetails?.country || showdefault?.country || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_zipcode")}</th>
                          <td>
                            {showdefault?.clubDetails?.zipCode || showdefault?.zipCode || showdefault?.zip || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Stripe & Billing Details */}
                    <div>
                      <h6 className="main-content-label mb-3">Stripe & Billing Details</h6>
                    </div>
                    <table id="stripe-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Stripe Customer ID</th>
                          <td>
                            {showdefault && showdefault?.stripeCustomerId
                              ? showdefault.stripeCustomerId
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Billing Status</th>
                          <td>
                            {showdefault && showdefault?.stripeCustomerId
                              ? <span className="badge badge-pill badge-success fw-bold text-uppercase">Active</span>
                              : <span className="badge badge-pill badge-primary-light fw-bold text-uppercase">{showdefault?.billingStatus ? showdefault.billingStatus.replace(/_/g, " ") : "N/A"}</span>}
                          </td>
                        </tr>
                        <tr>
                          <th>Default Payment Method</th>
                          <td>
                            {showdefault && showdefault?.paymentMethodName
                              ? <div>
                                  <span className="text-capitalize">{showdefault.paymentMethodName}</span>
                                  {showdefault.defaultPaymentMethodId && <div className="text-muted small mt-1">ID: {showdefault.defaultPaymentMethodId}</div>}
                                </div>
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Commercial Agreement Signed</th>
                          <td>
                            {showdefault && showdefault?.commercialAgreementSigned
                              ? (
                                <div className="d-flex align-items-center">
                                  <span className="text-success"><i className="fa fa-check-circle mr-1"></i> Yes</span>
                                </div>
                              )
                              : <span className="text-danger"><i className="fa fa-times-circle mr-1"></i> No</span>}
                          </td>
                        </tr>

                        <tr>
                          <th>Terms & Conditions Accepted</th>
                          <td>
                            {showdefault && showdefault?.isTermsAndConditionsAccepted
                              ? <span className="text-success"><i className="fa fa-check-circle mr-1"></i> Yes</span>
                              : <span className="text-danger"><i className="fa fa-times-circle mr-1"></i> No</span>}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="mt-5 d-flex gap-2">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                      <button
                        className="btn ripple btn-success text-white"
                        type="button"
                        onClick={() => navigate(`/admin/user-management/audit-logs/${params.id}`)}
                      >
                        <i className="ri-history-fill mx-1"></i>
                        View Audit Logs
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClubAdminView;
